export default "../../src/img/secure-with-macfee.webp";